<template>
    <div class="progress">

        <div
            :class="'progress-bar' + ' ' + color"
            role="progressbar"
            style="display: flex; align-items: center;"
            :style="'width:' + percentage + '%'"
            :aria-valuenow="percentage"
            :aria-valuemin="0"
            :aria-valuemax="goal"
        >

        </div>

    </div>

</template>

<script>
export default {
    name: "ProgressBar",
    props: {
        goal: {
            type: Number,
            required: true,
        },
        left: {
            type: Number,
            required: true,
        }
    },
    computed: {
        color() {

            if (this.percentage < 33) {
                return 'progress-bar-red';
            }

            if (this.percentage > 33 && this.percentage <= 66) {
                return 'progress-bar-light-blue';
            }

            if (this.percentage > 66) {
                return 'progress-bar-green';
            }

            return '';
        },
        percentage() {
            return this.goal !== 0 ? ((this.goal - this.left) * 100) / this.goal : 0;
        },
        progressBarCompletedNumber() {
            return this.goal - this.left;
        }
    }
}
</script>

<style scoped>
    .progress {
        height: 40px;
    }

    .progress-bar {
        font-size: 20px;
        line-height: 40px;

    }
</style>



// WEBPACK FOOTER //
// resources/js/admin-panel/components/common/ProgressBar.vue